/** Numeros para leer, no para contar ceros. */
export function num(n: number, max = 4): string {
  if (!Number.isFinite(n)) return "—";
  const abs = Math.abs(n);
  // `max` es un TOPE y se respeta siempre. Antes, por encima de 1.000 se forzaban 2 decimales
  // ignorandolo: en la misma fila salia "$583.015,82" al lado de "$9.266.864" y parecia que una
  // cifra estaba redondeada y la otra no.
  const dec = abs === 0 ? Math.min(max, 2)
    : abs < 0.01 ? Math.min(max, 8)
    : abs < 1000 ? Math.min(max, 4)
    : Math.min(max, 2);
  return n.toLocaleString("es", { maximumFractionDigits: dec });
}

export const corto = (a?: string) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "");

export function haceCuanto(ts: number): string {
  if (!ts) return "nunca";
  const s = Math.floor(Date.now() / 1000) - ts;
  if (s < 60) return "hace un momento";
  if (s < 3600) return `hace ${Math.floor(s / 60)} min`;
  if (s < 86400) return `hace ${Math.floor(s / 3600)} h`;
  return `hace ${Math.floor(s / 86400)} días`;
}

/**
 * Cuánto lleva algo funcionando: «3 d 4 h», «5 h 12 min», «recién abierta».
 *
 * Vive aquí y no en la lista porque la usan las DOS pantallas que enseñan piscinas —la privada y la
 * portada— y dos copias de la misma regla acaban divergiendo el día que alguien toque una.
 */
export function antiguedad(desde: number | undefined): string | null {
  if (!desde) return null;
  return duracion(Math.floor(Date.now() / 1000) - desde) ?? null;
}

/** Una DURACIÓN ya calculada (en segundos): cuánto vivió una piscina cerrada, p.ej. Mismo formato. */
export function duracion(seg: number | undefined): string | null {
  if (seg === undefined) return null;
  const s = Math.max(0, Math.floor(seg));
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d} d ${h} h`;
  if (h > 0) return `${h} h ${m} min`;
  return m > 0 ? `${m} min` : "< 1 min";
}
